import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import * as angular from 'angular';
import { AppRootScope } from '../../src';
import { $http, $log, $q, $timeout } from '../ajs-upgraded-providers';
import { AppContextService } from '../appContext/AppContextService';
import { EndpointService } from '../endpoint/EndpointService';
import { CommonBroadcastService } from '@caslink/common-client/ng-app/common-broadcast/common-broadcast.service';

@Injectable({
    providedIn: 'root'
})
export class ProxyServiceAdapter {
    // tslint:disable:member-ordering
    public static $name: string = 'proxyServiceAdapter';

    constructor(
        @Inject('$rootScope') public $rootScope: AppRootScope,
        @Inject($timeout) public $timeout: angular.ITimeoutService,
        public appContextService: AppContextService,
        public endpointService: EndpointService,
        @Inject($log) public $log: angular.ILogService,
        @Inject($q) public $q: angular.IQService,
        @Inject($http) public $http: angular.IHttpService,
        public httpClient: HttpClient,
        public commonBroadcastService: CommonBroadcastService,
    ) {
    }
}
